import { PDF_BORDER, ReportPage, ReportTable } from '@/components';
import type { StandardFundReportProps } from '@/features/mold/utils/pdf/pdf-components-props';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const StandardFundReportForPrivateFormat: FC<
  StandardFundReportProps
> = ({ fiscalYear, header, rowData, footer, dateByCreated, paperSize }) => {
  const { t } = useTranslation();
  return (
    <ReportPage
      title={{
        text: t('report-standard-fund-title', {
          year: fiscalYear,
        }),
        variant: 'small',
      }}
      layout={{ paperSize, orientation: 'landscape' }}
      pagePadding={5}
      caption={{
        unit: 'thousand',
      }}
      dateByCreated={dateByCreated}
    >
      <ReportTable
        header={header}
        data={rowData}
        footer={footer}
        tableWidth="100%"
        defaultBorderStyle={PDF_BORDER.THIN}
        borderColor="secondary"
      />
    </ReportPage>
  );
};
